/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import MESSANGER from '../BaseComponent/MESSANGER'
import $ from 'jquery'
import InputMask from 'react-input-mask'
import TMS from '../BaseComponent/TMS'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'

class ReportSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      printInfo: [],
      excelReport: [],
      editModal: false,
      deleteModal: false,
      department: [],
      departmentId: '',
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'departmentId_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دپارتمان',
          value: 'departmentId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'عنوان',
          value: 'title',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'فعال',
          value: 'active',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: ' edit',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'حذف',
          value: 'delete',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  // (params = sessionStorage.getItem('params')
  //     ,pageNumber = sessionStorage.getItem('pageNumber')
  //     ,pageSize = sessionStorage.getItem('dropDownVal')
  // )

  getAll = (exportStatus) => {
    let filter = this.createFilter(exportStatus)

    http
      .get(`${TMS.TMS_MANAGE_BASE_SECTION_REPORT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll
            })
            $('.showBaseTable').fadeIn()
          } else {
            this.setState({
              printInfo: response.data.object.result,
              excelReport: response.data.object.result,
              countAll: response.data.object.countAll
            })
          }
        } else {
          this.setState({
            list: [],
            printInfo: [],
            excelReport: [],
            countAll: ''
          })
          $('.showBaseTable').fadeOut()
        }
      })
  }

  componentDidMount() {
    this.getAll(false)

    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      } else {
        this.setState({
          department: []
        })
      }
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAll(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAll(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAll(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    return filter
  }

  filter() {
    // sessionStorage.setItem("params", `name=${name}&bank=${bank}`);

    this.getAll(false)
  }

  activate = (enabled, id) => {
    if (enabled) {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_SECTION_DISABLE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    } else {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_SECTION_ENABLE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  edit = (id, title, departmentId) => {
    this.setState({
      id,
      title,
      departmentId,
      editModal: !this.state.editModal
    })
  }
  editToggle = () => {
    this.setState({
      id: '',
      title: '',
      content: '',
      coder: '',
      sortOrder: '',
      editModal: !this.state.editModal,
      departmentId: ''
    })
  }
  editCancel = () => {
    this.editToggle()
  }

  editOk = () => {
    let departmentId = document.getElementById('departmentId').value
    let {id, title} = this.state
    let titleError = false
    let orgError = false
    let formError = false
    if (title === '') {
      message.error('عنوان وارد شود')
      titleError = true
      formError = true
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }

    if (departmentId === '') {
      message.error('دپارتمان وارد شود')
      orgError = true
      formError = true
    } else {
      if (!orgError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        id,
        title,
        departmentId
      }
      http.post(`${TMS.TMS_MANAGE_BASE_SECTION_UPDATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('بخش ویرایش شد')
          this.getAll()
          this.editToggle()
        } else {
          // message.error(response.data.description)
        }
      })
    }
  }

  delete = (id, title) => {
    this.setState({
      id,
      title,
      deleteModal: !this.state.deleteModal
    })
  }
  toggleCancelDelete = () => {
    this.setState({
      id: '',
      title: '',
      deleteModal: !this.state.deleteModal
    })
  }
  deleteCancel = () => {
    this.toggleCancelDelete()
  }
  deleteOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    http.post(`${TMS.TMS_MANAGE_BASE_SECTION_DELETE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('بخش با موفقیت حذف شد')
        this.getAll()
        this.toggleCancelDelete()
      } else {
        this.setState({
          deleteModal: false
        })
      }
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: this.state.countAll
    })
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  exportExcel = () => {
    this.getAll(true)

    let {excelReport} = this.state
    for (let i = 0; i < excelReport.length; i++) {
      if (excelReport[i]['enabled']) {
        excelReport[i]['enabled'] = 'فعال'
      } else {
        excelReport[i]['enabled'] = 'غیر فعال'
      }
    }

    this._export.save(this.state.excelReport)
  }

  getPrintInfo = () => {
    this.getAll(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {pageNumber, pageSize} = this.state
    let printCol = ['ردیف', 'عنوان', 'وضعیت']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="اطلاعات پایه بخش ها"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((temp, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{temp.title}</td>
                  <td>{temp.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="اطلاعات پایه بخش ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'departmentTitle'}
                field={'departmentTitle'}
                title={'دپارتمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت وظایف</li>
            <li>بخش ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/base/create/tms/sections"
                  url={TMS.TMS_MANAGE_BASE_SECTION_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={TMS.TMS_MANAGE_BASE_SECTION_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.list.map((temp, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{temp.departmentTitle}</td>
                      <td>{temp.title}</td>
                      <td>
                        <button onClick={() => this.activate(temp.enabled, temp.id)}>
                          {temp.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.edit(temp.id, temp.title, temp.departmentId)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(temp.id, temp.title)}>
                          <img src={require('../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
                {/*<Page defaultCurrent={1} total={this.state.countAll}*/}
                {/*      onResultFetched={this.onResultFetched.bind(this)} url={TMS.TMS_MANAGE_BASE_SECTION_REPORT}/>*/}
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.deleteModal} toggle={this.toggleCancelDelete} size="sm">
          <ModalHeader toggle={this.toggleCancelDelete}>حذف انبار</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف متن {this.state.title} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.editToggle} size="sm">
          <ModalHeader toggle={this.editToggle}>ویرایش متن آماده پیام رسان</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>
                  دپارتمان <span className="requireFiled">*</span>
                </label>
                <select className="form-control" id="departmentId">
                  <option value="">------</option>
                  {this.state.department.map((item, index) => (
                    <option selected={Number(item.id) === this.state.departmentId ? true : false} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>
                  {' '}
                  عنوان : <span className="requireFiled">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="title"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.title}
                  id="title"
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportSection
